import { useState, FormEvent } from "react";

const FORM_URL = "https://readdy.ai/api/form/d6tf897crcujsk0v1900";

const interests = [
  "Hotel Jardín Tecina",
  "Playitas Resort",
  "FAM Trip / Wizyta studyjna",
  "Warsztaty B2B",
  "Networking",
  "Partnerstwo strategiczne",
];

export default function MHContact() {
  const [selected, setSelected] = useState<string[]>([]);
  const [status, setStatus] = useState<"idle" | "sending" | "success" | "error">("idle");
  const [charCount, setCharCount] = useState(0);

  const toggle = (item: string) =>
    setSelected((prev) => prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus("sending");
    const form = e.currentTarget;
    const data = new URLSearchParams();
    new FormData(form).forEach((val, key) => data.append(key, val as string));
    if (selected.length > 0) data.append("zainteresowania", selected.join(", "));
    try {
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });
      if (res.ok) { setStatus("success"); form.reset(); setSelected([]); setCharCount(0); }
      else setStatus("error");
    } catch { setStatus("error"); }
  };

  return (
    <section id="contact" className="bg-gray-950 py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-16 items-start">

          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="h-1 w-10 rounded-full" style={{ backgroundColor: "#CC1F1A" }} />
              <span className="text-sm font-bold uppercase tracking-widest text-gray-400">Kontakt</span>
            </div>
            <h2 className="text-4xl lg:text-5xl font-extrabold text-white uppercase leading-tight mb-6">
              Zacznijmy<br />
              <span style={{ color: "#FFD100" }}>współpracę</span>
            </h2>
            <p className="text-gray-400 leading-relaxed mb-10">
              Chcesz dołączyć do sieci Meet Hiszpania? Masz pytania o konkretnego partnera,
              event lub wizytę studyjną? Napisz do nas.
            </p>

            <div className="flex flex-col gap-6 mb-10">
              {[
                { icon: "ri-mail-line", label: "Email", value: "info@hiszpaniadeluxe.com", href: "mailto:info@hiszpaniadeluxe.com" },
                { icon: "ri-phone-line", label: "Telefon", value: "+48 728 958 974", href: "tel:+48728958974" },
                { icon: "ri-whatsapp-line", label: "WhatsApp", value: "+48 728 958 974", href: "https://wa.me/48728958974" },
              ].map((item) => (
                <a key={item.label} href={item.href} className="flex items-center gap-4 group">
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl text-white transition-colors"
                    style={{ backgroundColor: "#CC1F1A" }}>
                    <i className={`${item.icon} text-xl`} />
                  </div>
                  <div>
                    <p className="text-xs text-gray-500 uppercase tracking-wider font-medium">{item.label}</p>
                    <p className="text-white font-semibold group-hover:text-yellow-300 transition-colors">{item.value}</p>
                  </div>
                </a>
              ))}
            </div>

            <div className="p-6 rounded-xl border border-white/10 bg-white/5">
              <p className="text-gray-400 text-sm leading-relaxed italic">
                "Naszą misją jest tworzenie długofalowych partnerstw między polską branżą turystyczną
                a najlepszymi destynacjami w Hiszpanii."
              </p>
            </div>
          </div>

          <div className="bg-gray-900 rounded-xl p-8 border border-white/5">
            {status === "success" ? (
              <div className="text-center py-16">
                <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-5 text-white"
                  style={{ backgroundColor: "#CC1F1A" }}>
                  <i className="ri-check-line text-3xl" />
                </div>
                <h3 className="text-xl font-bold text-white uppercase mb-2">Dziękujemy!</h3>
                <p className="text-gray-400 text-sm">Skontaktujemy się z Tobą wkrótce.</p>
                <button onClick={() => setStatus("idle")} className="mt-6 text-xs font-bold uppercase tracking-widest cursor-pointer" style={{ color: "#CC1F1A" }}>
                  Wyślij kolejną wiadomość
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} data-readdy-form>
                <h3 className="text-lg font-extrabold text-white uppercase tracking-wide mb-6">Napisz do nas</h3>

                <div className="grid grid-cols-2 gap-4 mb-4">
                  <div>
                    <label className="block text-xs font-bold text-gray-400 uppercase tracking-wider mb-1.5">Imię i nazwisko *</label>
                    <input type="text" name="imie_nazwisko" required
                      className="w-full bg-gray-800 border border-gray-700 rounded-lg px-3 py-2.5 text-sm text-white placeholder-gray-600 focus:outline-none focus:border-red-600 transition-colors"
                      placeholder="Jan Kowalski" />
                  </div>
                  <div>
                    <label className="block text-xs font-bold text-gray-400 uppercase tracking-wider mb-1.5">Email *</label>
                    <input type="email" name="email" required
                      className="w-full bg-gray-800 border border-gray-700 rounded-lg px-3 py-2.5 text-sm text-white placeholder-gray-600 focus:outline-none focus:border-red-600 transition-colors"
                      placeholder="jan@agencja.pl" />
                  </div>
                </div>

                <div className="mb-4">
                  <label className="block text-xs font-bold text-gray-400 uppercase tracking-wider mb-1.5">Firma / Agencja</label>
                  <input type="text" name="firma"
                    className="w-full bg-gray-800 border border-gray-700 rounded-lg px-3 py-2.5 text-sm text-white placeholder-gray-600 focus:outline-none focus:border-red-600 transition-colors"
                    placeholder="Nazwa agencji turystycznej" />
                </div>

                <div className="mb-4">
                  <label className="block text-xs font-bold text-gray-400 uppercase tracking-wider mb-2">Interesuje mnie</label>
                  <div className="flex flex-wrap gap-2">
                    {interests.map((item) => (
                      <button type="button" key={item} onClick={() => toggle(item)}
                        className="text-xs font-semibold px-3 py-1.5 rounded-lg border transition-all cursor-pointer whitespace-nowrap"
                        style={selected.includes(item)
                          ? { backgroundColor: "#CC1F1A", borderColor: "#CC1F1A", color: "white" }
                          : { borderColor: "#374151", color: "#9CA3AF" }}>
                        {item}
                      </button>
                    ))}
                  </div>
                </div>

                <div className="mb-6">
                  <label className="block text-xs font-bold text-gray-400 uppercase tracking-wider mb-1.5">Wiadomość</label>
                  <textarea name="wiadomosc" rows={4} maxLength={500}
                    onChange={(e) => setCharCount(e.target.value.length)}
                    className="w-full bg-gray-800 border border-gray-700 rounded-lg px-3 py-2.5 text-sm text-white placeholder-gray-600 focus:outline-none focus:border-red-600 transition-colors resize-none"
                    placeholder="Napisz, czego szukasz..." />
                  <p className="text-xs text-gray-600 text-right mt-1">{charCount}/500</p>
                </div>

                {status === "error" && <p className="text-red-400 text-xs mb-4">Wystąpił błąd. Spróbuj ponownie.</p>}

                <button type="submit" disabled={status === "sending"}
                  className="w-full py-3.5 text-sm font-extrabold text-white rounded-lg uppercase tracking-widest hover:opacity-90 transition-colors cursor-pointer disabled:opacity-60 whitespace-nowrap"
                  style={{ backgroundColor: "#CC1F1A" }}>
                  {status === "sending" ? "Wysyłanie..." : "Wyślij zapytanie"}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
